/**
 * The full-bleed progress bar (spec §2.1): 3 px, pinned to the top of the
 * viewport, above everything. It is the ONE progress indicator that survives
 * the mobile collapse where the chapter rail does not, so it is deliberately
 * `position: fixed` rather than a child of the layout.
 */
export function ProgressBar({ pct }: { pct: number }): React.JSX.Element {
  const clamped = Math.max(0, Math.min(100, pct));
  return (
    <div
      role="progressbar"
      aria-label="Setup progress"
      aria-valuenow={Math.round(clamped)}
      aria-valuemin={0}
      aria-valuemax={100}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        background: "rgba(255,255,255,.06)",
        zIndex: 40,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          height: "100%",
          width: `${clamped}%`,
          background: "linear-gradient(90deg,#FFD500,#FFA500)",
          transition: "width .3s var(--ql-ease)",
        }}
      />
    </div>
  );
}
